import { TextHeader } from 'components/Typography/TextHeader';
import { AppContainer } from 'components/Container';
import { header, heading, logo, hero, digital, headerWrapper } from './styles.module.scss';
import logoSVG from '../../assets/images/logo.svg';

const Header = () => {
  return (
    <header role="banner" className={`${header} row`}>
      <AppContainer>
        <div className={headerWrapper}>
          <div className={logo}>
            {/* desktop logo */}
            <svg className={hero} viewBox="0 0 198 40">
              <title>Virgin Money</title>
              <circle xmlns="http://www.w3.org/2000/svg" cx="69.9375" cy="20.375" r="19" />
              <use xlinkHref={`${logoSVG}#hero`} />
            </svg>

            {/* mobile logo */}
            <svg className={digital} viewBox="0 0 94 54" preserveAspectRatio="xMaxYMax slice">
              <title>Virgin Money</title>
              <use xlinkHref={`${logoSVG}#digital`} />
            </svg>
          </div>

          <TextHeader className={heading} type="h1">
            Customer number reveal
          </TextHeader>
        </div>
      </AppContainer>
    </header>
  );
};

export { Header };
